import type { MultiSelectOption } from '@/components/multi-select-field';

/**
 * Device Type filter options — the device-type registry codes the
 * patient-search index stores per device slot. Shared by the All Patients
 * roster filters and the billing tables' filters so both facets offer the
 * exact same vocabulary (both resolve in the same OpenSearch query).
 */
export const DEVICE_TYPE_OPTIONS: MultiSelectOption[] = [
  { value: 'CRT_D', label: 'CRT-D' },
  { value: 'CRT_P', label: 'CRT-P' },
  { value: 'ICD', label: 'ICD' },
  { value: 'ILR', label: 'ILR' },
  { value: 'PPM', label: 'PPM' },
];
